import CheckmateApiClient from '../../services/apiClient';
import { useQuery } from 'react-query';

const _apiClient = new CheckmateApiClient();

export const useGetUserCaseFileModels = (isLoggedIn?: boolean) => {
    return useQuery({
        queryKey: ['get-quad-user-case-file-models'],
        queryFn: async () => {
            const response = await _apiClient.getUserCaseFileModels();

            if (response.httpResponse.status === 401) {
                window.location.reload();
            }

            if (response.httpResponse.status === 500) {
                throw new Error('Failed to retrieve user case file models.');
            } else if (response.errorMessage) {
                throw new Error(response.errorMessage);
            }

            return response.payload;
        },
        enabled: !!isLoggedIn,
    });
};
